import React, { useEffect, useRef, useState } from 'react'

// Inline title editor swapped into a ToC row. Enter/blur submits, Escape
// cancels. Submitting an empty or unchanged title cancels instead of saving.
// NOTE: no tabindex attribute here - the global base_template.jsm handler
// turns Enter into a synthetic click on [tabindex] elements.
export const TocInlineRename = ({ initialValue, onSubmit, onCancel }) => {
  const [value, setValue] = useState(initialValue || '')
  const inputRef = useRef(null)
  const doneRef = useRef(false)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [])

  const submit = () => {
    if (doneRef.current) return
    doneRef.current = true
    const trimmed = value.trim()
    if (!trimmed || trimmed === (initialValue || '').trim()) {
      onCancel()
    } else {
      onSubmit(trimmed)
    }
  }

  const cancel = () => {
    if (doneRef.current) return
    doneRef.current = true
    onCancel()
  }

  return (
    <input
      ref={inputRef}
      type="text"
      className="toc-inline-rename"
      value={value}
      aria-label="New title"
      onChange={event => setValue(event.target.value)}
      onClick={event => event.stopPropagation()}
      onKeyDown={event => {
        // keep arrows/enter/escape from triggering the ToC-wide menu navigation
        event.stopPropagation()
        if (event.key === 'Enter') {
          event.preventDefault()
          submit()
        } else if (event.key === 'Escape') {
          event.preventDefault()
          cancel()
        }
      }}
      onBlur={submit}
    />
  )
}
